module.exports = __webpack_public_path__ + "static/media/icon-arrow-right.d66d5ea3.svg";